const { fetchWithRetry } = require('./utils'); // A utility function to parse cookies  

// Function to create a merch purchase  
const createMerchPurchase = async (merchPurchaseData) => {
    try {
        const response = await fetchWithRetry('/api/merchPurchase', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(merchPurchaseData),
        });

        if (!response.ok) {
            throw new Error(`Error creating merch purchase: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error creating merch purchase:', error);
        throw error;
    }
};

// Function to fetch all merch purchases  
const fetchAllMerchPurchases = async () => {
    try {
        const response = await fetchWithRetry('/api/merchPurchases', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error fetching merch purchases: ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching merch purchases:', error);
        throw error;
    }
};

module.exports = {
    createMerchPurchase,
    fetchAllMerchPurchases,
};  